import { ReceiptService } from '@/services/receipts.service'
export default {
  methods: {
    canEdit(status) {
      return status === 'NEW' && this.dataPermission.includes('CNPS_SCON_REFUND_EDIT')
    },
    canApprovenReject(status) {
      return status === 'WAIT_APPROVE' && this.dataPermission.includes('CNPS_SCON_REFUND_APPROVE')
    },
    canCancel(status) {
      return (
        (status === 'NEW' || status === 'WAIT_APPROVE') &&
        this.dataPermission.includes('CNPS_SCON_REFUND_CANCEL')
      )
    },
    detailItem(id) {
      const routeData = this.$router.resolve({
        path: `/list-refund/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    async sendApprove(id) {
      try {
        this.loading = true
        const data = await ReceiptService.sendApproveRefund({
          id: id,
        })
        if (data.success) {
          this.showSuccessMx('Gửi duyệt thông tin hoàn tiền thành công')
          await this.fetchData()
        } else {
          this.showFailMx(data.message)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async approve(id) {
      try {
        this.loading = true
        const data = await ReceiptService.approveRefund({
          id: id,
        })
        if (data.success) {
          this.showSuccessMx('Duyệt hoàn tiền thành công')
          await this.fetchData()
        } else {
          this.showFailMx(data.message)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async reject(id) {
      const { value: flag, note } = await this.rejectMx()
      if (flag === true) {
        try {
          this.loading = true
          const res = await ReceiptService.rejectedRefund({ id: id, reason: note })
          if (res.success === true) {
            await this.fetchData()
            this.showSuccessMx('Từ chối hoàn tiền thành công')
          } else this.showFailMx(res.message)
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      }
    },
    async changeStatus(item) {
      const confirm = await this.approveMx(
        `Bạn có chắc chắn muốn huỷ thông tin hoàn tiền đối với phiếu hoàn tiền ${item.code} không?`
      )
      if (confirm) {
        try {
          this.loading = true
          const res = await ReceiptService.cancelRefund({
            id: item.id,
          })
          if (res.success) {
            this.showSuccessMx('Huỷ thông tin hoàn tiền thành công')
            await this.fetchData()
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    },
  },
}
